// extracted by mini-css-extract-plugin
export default {"container":"APICard_container__7m0VF","content":"APICard_content__fddyP","footer_action":"APICard_footer_action__1QXDK","service_title":"APICard_service_title__+eI7h"};